// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
function isTextEditingTarget(target) {
    return (target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        (target instanceof HTMLElement && target.isContentEditable));
}
export function wireMainBarActions(options) {
    var _a, _b, _c;
    const { connect, disconnect, isConnected, sendCommand, getGraphSettings, debugBtn, verboseBtn, parallelismInput, playPauseBtn, getOperationNames, setSelection, clearSelection, hasSelection, render } = options;
    const connectBtn = (_a = document.getElementById('connect-btn')) !== null && _a !== void 0 ? _a : undefined;
    if (connectBtn) {
        connectBtn.addEventListener('click', () => {
            if (isConnected()) {
                disconnect();
            }
            else {
                connect();
            }
        });
    }
    const executeBtn = (_b = document.getElementById('execute-btn')) !== null && _b !== void 0 ? _b : undefined;
    if (executeBtn) {
        executeBtn.addEventListener('click', () => sendCommand({ command: 'execute' }));
    }
    const abortBtn = (_c = document.getElementById('abort-execution-btn')) !== null && _c !== void 0 ? _c : undefined;
    if (abortBtn) {
        abortBtn.addEventListener('click', () => sendCommand({ command: 'abort-execution' }));
    }
    if (debugBtn) {
        debugBtn.addEventListener('click', () => {
            var _a;
            const newVal = !((_a = getGraphSettings()) === null || _a === void 0 ? void 0 : _a.debugMode);
            debugBtn.title = newVal ? 'Turn off debug logging' : 'Turn on debug logging';
            sendCommand({ command: 'set-debug', value: newVal });
        });
    }
    if (verboseBtn) {
        verboseBtn.addEventListener('click', () => {
            var _a;
            const newVal = !((_a = getGraphSettings()) === null || _a === void 0 ? void 0 : _a.verbose);
            verboseBtn.title = newVal ? 'Turn off verbose logging' : 'Turn on verbose logging';
            sendCommand({ command: 'set-verbose', value: newVal });
        });
    }
    if (parallelismInput) {
        parallelismInput.addEventListener('change', () => {
            const value = Number(parallelismInput.value) || 1;
            sendCommand({ command: 'set-parallelism', parallelism: value });
        });
    }
    if (playPauseBtn) {
        playPauseBtn.addEventListener('click', () => {
            const graphSettings = getGraphSettings();
            if (!graphSettings)
                return;
            const next = !!graphSettings.pauseNextIteration;
            sendCommand({ command: 'set-pause-next-iteration', value: !next });
        });
    }
    window.addEventListener('keydown', (e) => {
        var _a;
        if (e.key === 'a' && (e.metaKey || e.ctrlKey) && !isTextEditingTarget((_a = e.target) !== null && _a !== void 0 ? _a : undefined)) {
            e.preventDefault();
            setSelection(new Set(getOperationNames()));
            render();
        }
        if (e.key === 'Escape' && hasSelection()) {
            clearSelection();
            render();
        }
    });
}
//# sourceMappingURL=mainBar.js.map